import { jsx as r } from "@emotion/react/jsx-runtime";
import { Chart as m, CategoryScale as i, BarElement as h, ArcElement as u, LineElement as p, LinearScale as C, PointElement as l, Title as c, Tooltip as s, Legend as f } from "chart.js";
import d from "chartjs-plugin-annotation";
import { BarChart as g } from "./Bar/index.js";
import { ChartProvider as L, useChartContext as B } from "./ChartContext.js";
import { DoughnutChart as E } from "./Dougnhut/index.js";
import { LineChart as x } from "./Line/index.js";
import { QuadrantChart as y } from "./Quadrant/index.js";
import { ChartType as t } from "../../types/components/chart.js";
m.register(i, h, u, p, C, l, c, s, f, d);
const P = () => {
  const {
    type: e
  } = B();
  switch (e) {
    case t.Doughnut:
      return /* @__PURE__ */ r(E, {});
    case t.Bar:
      return /* @__PURE__ */ r(g, {});
    case t.Line:
      return /* @__PURE__ */ r(x, {});
    case t.Quadrant:
      return /* @__PURE__ */ r(y, {});
    default:
      return null;
  }
}, b = ({
  dataTrackId: e,
  type: o = t.Bar,
  options: a,
  data: n
}) => /* @__PURE__ */ r(L, { dataTrackId: e, type: o, options: a, data: n, children: /* @__PURE__ */ r(P, {}) });
export {
  b as Chart
};
